(ns common.schema.entities.fund.schema
  (:require
   [common.currencies :as currencies]
   [common.schema.constraints :as constraints]
   [common.schema.schema-utils :as su]
   [common.country :as country]
   #?(:cljs [cljs.reader :as edn])
   #?(:clj [clojure.edn :as edn])))

(defonce import-fixed-fields [:fund/name])

(def schema
  (vec
   (concat
    [[:fund/name
      {:field/data-type             :data.type/text-simple
       :field/mandatory             :mandatory/always
       :field/name-attribute        :fund/name
       :field/system-required?      true
       :field/system-semantics      su/user-provided-system-required-field-semantics
       :field/default-visibility    {:editor           :editor.type/link
                                     :grid             :editor.type/text-simple
                                     :filter           :filter.type/text
                                     :field-visibility :in-use-disabled}
       :field/lower-case-str?       true
       :field/not-clearable?        true
       :field/constraints           {:constraint/string-min-length 1
                                     :constraint/unique-tenant-ignore-case
                                     {:validation-fn (partial constraints/tenant-unique-ignore-case
                                                              :fund/name
                                                              [:entity.type/fund])}}
       :field/default-authorization {:access/read  :role/guest-lp-portal
                                     :access/write :role/user}
       :field/translations          {:en "Name"}}]
     [:fund/general-partner
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :field/entity-types          [:entity.type/company]
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :create-on-fly?              true
       :field/translations          {:en "General partner"}}]
     [:fund/management-company
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :field/entity-types          [:entity.type/company]
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :create-on-fly?              true
       :field/translations          {:en "Management company"}}]
     [:fund/status
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :field/mandatory             :mandatory/always
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/status
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Our fund status"}
       :field/short-name            {:en "Status"}}]
     [:fund/cur-fund-size
      {:field/data-type             :data.type/currency-value
       :field/secondary-attribute   :fund/cur-target-size--sym
       :field/constraints           {:constraint/number-positive        true
                                     :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility    {:editor           :editor.type/number
                                     :grid             :editor.type/number
                                     :filter           :filter.type/number
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Our fund size"}}]
     [:fund/cur-fund-size--sym
      {:field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Our fund size (currency)"}
       :field/data-type             :data.type/currency-symbol
       :field/secondary-field?      true
       :field/not-clearable?        true
       :field/related-fields        :fund/cur-target-size
       :options                     currencies/options
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :value-type                  :keyword}]
     [:fund/cur-target-size
      {:field/data-type             :data.type/currency-value
       :field/secondary-attribute   :fund/cur-target-size--sym
       :field/constraints           {:constraint/number-positive        true
                                     :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility    {:editor           :editor.type/number
                                     :grid             :editor.type/number
                                     :filter           :filter.type/number
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Target size"}}]
     [:fund/cur-target-size--sym
      {:field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Target size (currency)"}
       :field/data-type             :data.type/currency-symbol
       :field/secondary-field?      true
       :field/not-clearable?        true
       :field/related-fields        :fund/cur-target-size
       :options                     currencies/options
       :field/default-visibility    {:editor :editor.type/select
                                     :grid   :editor.type/select
                                     :filter :filter.type/select
                                     :field-visibility :in-use}
       :value-type                  :keyword}]
     [:fund/accounting-period-end-date-month
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor :editor.type/integer
                                     :grid   :editor.type/integer
                                     :filter :filter.type/integer
                                     :field-visibility :in-use}
       :field/constraints           {:constraint/greater-than-inclusive 1
                                     :constraint/smaller-than-inclusive 12}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Accounting period end - month"}}]
     [:fund/accounting-period-end-date-day
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor :editor.type/integer
                                     :grid   :editor.type/integer
                                     :filter :filter.type/integer
                                     :field-visibility :in-use}
       :field/constraints           {:constraint/greater-than-inclusive 1
                                     :constraint/smaller-than-inclusive 31}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Accounting period end - day"}}]
     [:fund/number-of-closings-occurred
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor           :editor.type/integer
                                     :grid             :editor.type/integer
                                     :filter           :filter.type/integer
                                     :field-visibility :in-use}
       :field/constraints           {:constraint/greater-than-inclusive 0
                                     :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Number of closings occurred"}}]
     [:fund/expected-number-of-closings
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor           :editor.type/integer
                                     :grid             :editor.type/integer
                                     :filter           :filter.type/integer
                                     :field-visibility :in-use}
       :field/constraints           {:constraint/greater-than-inclusive 1
                                     :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Expected number of closings"}}]
     [:fund/term-end-date
      {:field/data-type             :data.type/datetime
       :field/default-visibility    {:editor           :editor.type/date
                                     :grid             :editor.type/date
                                     :filter           :filter.type/date
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Term end date"}}]
     [:fund/first-closing-date
      {:field/data-type             :data.type/datetime
       :field/default-visibility    {:editor           :editor.type/date
                                     :grid             :editor.type/date
                                     :filter           :filter.type/date
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "First closing date"}}]
     [:fund/final-closing-date
      {:field/data-type             :data.type/datetime
       :field/default-visibility    {:editor           :editor.type/date
                                     :grid             :editor.type/date
                                     :filter           :filter.type/date
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Final closing date"}}]
     [:fund/first-investment-date
      {:field/data-type             :data.type/datetime
       :field/default-visibility    {:editor :editor.type/date
                                     :grid   :editor.type/date
                                     :filter :filter.type/date
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "First investment date"}}]
     [:fund/latest-capital-call
      {:field/data-type             :data.type/datetime
       :field/default-visibility    {:editor           :editor.type/date
                                     :grid             :editor.type/date
                                     :filter           :filter.type/date
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Latest capital call"}}]
     [:fund/investment-period-end-date
      {:field/data-type             :data.type/datetime
       :field/default-visibility    {:editor           :editor.type/date
                                     :grid             :editor.type/date
                                     :filter           :filter.type/date
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Investment period end date"}}]
     [:fund/vintage-year
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor           :editor.type/integer
                                     :grid             :editor.type/integer
                                     :filter           :filter.type/integer
                                     :field-visibility :in-use}
       :field/constraints           {:constraint/greater-than-inclusive 1960
                                     :constraint/smaller-than-inclusive 2100}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Vintage year"}}]
     [:fund/term
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor :editor.type/integer
                                     :grid   :editor.type/integer
                                     :filter :filter.type/integer
                                     :field-visibility :in-use}
       :field/constraints           {:constraint/greater-than-inclusive 1}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Term"}}]
     [:fund/number-of-extensions-permitted
      {:field/data-type             :data.type/integer
       :field/default-visibility    {:editor           :editor.type/integer
                                     :grid             :editor.type/integer
                                     :filter           :filter.type/integer
                                     :field-visibility :in-use}
       :field/constraints           {:constraint/greater-than-inclusive 0
                                     :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Number of extensions permitted"}}]
     [:fund/management-fee
      {:field/data-type             :data.type/percentage
       :field/default-visibility    {:editor           :editor.type/percentage
                                     :grid             :editor.type/percentage
                                     :filter           :filter.type/percentage
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Management fee (%)"}}]]
    [[:fund/domicile
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/domicile
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Domicile"}}]
     [:fund/management-fees-provision
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/management-fees-provision
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Management fees provision"}}]
     [:fund/legal-form
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/legal-form
       :field/default-visibility    {:editor :editor.type/select
                                     :grid   :editor.type/select
                                     :filter :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Legal form"}}]
     [:fund/fund-structure
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/fund-structure
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Our fund structure"}}]
     [:fund/currency
      {:field/data-type             :data.type/currency-symbol
       :value-type                  :keyword
       :field/not-clearable?        true
       :options                     currencies/options
       :field/default-visibility    {:editor :editor.type/select
                                     :grid   :editor.type/select
                                     :filter :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Our fund currency"}}]
     [:fund/transaction-fees-paid-by
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/transaction-fees-paid-by
       :field/default-visibility    {:editor :editor.type/select
                                     :grid   :editor.type/select
                                     :filter :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Transaction fees paid by"}}]
     [:fund/carried-interest
      {:field/data-type             :data.type/percentage
       :field/default-visibility    {:editor           :editor.type/percentage
                                     :grid             :editor.type/percentage
                                     :filter           :filter.type/percentage
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Carried interest (%)"}}]
     [:fund/hurdle-rate
      {:field/data-type             :data.type/percentage
       :field/default-visibility    {:editor           :editor.type/percentage
                                     :grid             :editor.type/percentage
                                     :filter           :filter.type/percentage
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Hurdle rate (%)"}}]
     [:fund/GP-removal-majority-requirement
      {:field/data-type             :data.type/percentage
       :field/default-visibility    {:editor           :editor.type/percentage
                                     :grid             :editor.type/percentage
                                     :filter           :filter.type/percentage
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "GP removal majority requirement (%)"}}]
     [:fund/maximum-investment-percentage-per-asset
      {:field/data-type             :data.type/percentage
       :field/default-visibility    {:editor :editor.type/percentage
                                     :grid   :editor.type/percentage
                                     :filter :filter.type/percentage
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Maximum investment per asset (% of fund)"}}]
     [:fund/minimum-stake-after-investment
      {:field/data-type             :data.type/percentage
       :field/default-visibility    {:editor :editor.type/percentage
                                     :grid   :editor.type/percentage
                                     :filter :filter.type/percentage
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Minimum stake after investment (%)"}}]
     [:fund/co-investment-rights
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor :editor.type/textarea
                                     :grid   :editor.type/textarea
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Co-investment rights"}}]
     [:fund/valuation-policy
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor           :editor.type/textarea
                                     :grid             :editor.type/textarea
                                     :filter           :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Valuation policy"}}]
     [:fund/ESG-policy
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor :editor.type/textarea
                                     :grid   :editor.type/textarea
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "ESG policy"}}]
     [:fund/ESG-restrictions
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor           :editor.type/textarea
                                     :grid             :editor.type/textarea
                                     :filter           :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "ESG restrictions"}}]
     [:fund/statement-of-compliance
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor :editor.type/textarea
                                     :grid   :editor.type/textarea
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Statement of compliance"}}]
     [:fund/transaction-fee-accrual-to-fund
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor :editor.type/textarea
                                     :grid   :editor.type/textarea
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Transaction fee accrual to fund"}}]
     [:fund/re-investment-policy
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor :editor.type/textarea
                                     :grid   :editor.type/textarea
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Re-investment policy"}}]
     [:fund/maximum-bridge-finance-facility
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor :editor.type/textarea
                                     :grid   :editor.type/textarea
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Maximum bridge finance facility"}}]
     [:fund/extension-approval-process
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor :editor.type/textarea
                                     :grid   :editor.type/textarea
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Extension approval process"}}]
     [:fund/clawback-provision
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor :editor.type/textarea
                                     :grid   :editor.type/textarea
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Clawback provision"}}]
     [:fund/distribution-waterfall
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/distribution-waterfall
       :field/default-visibility    {:editor :editor.type/select
                                     :grid   :editor.type/select
                                     :filter :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Distribution waterfall"}}]
     [:fund/accounting-principles
      {:field/data-type             :data.type/ref-single
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/accounting-principles
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Accounting principles"}}]
     [:fund/cur-maximum-investment-per-asset
      {:field/data-type             :data.type/currency-value
       :field/secondary-attribute   :fund/cur-maximum-investment-per-asset--sym
       :field/constraints           {:constraint/number-positive        true
                                     :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility    {:editor           :editor.type/number
                                     :grid             :editor.type/number
                                     :filter           :filter.type/number
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Maximum investment per asset"}}]
     [:fund/cur-maximum-investment-per-asset--sym
      {:field/data-type             :data.type/currency-symbol
       :field/secondary-field?      true
       :field/not-clearable?        true
       :field/related-fields        :fund/cur-maximum-investment-per-asset
       :options                     currencies/options
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :value-type                  :keyword
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Maximum investment per asset (currency)"}}]
     [:fund/ESG-policy-url
      {:field/data-type             :data.type/text-url
       :field/default-visibility    {:editor :editor.type/url
                                     :grid   :editor.type/url
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations          {:en "ESG policy link"}}]
     [:fund/ESG-restrictions-url
      {:field/data-type             :data.type/text-url
       :field/default-visibility    {:editor           :editor.type/url
                                     :grid             :editor.type/url
                                     :filter           :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations          {:en "ESG restrictions link"}}]
     [:fund/statement-of-compliance-url
      {:field/data-type             :data.type/text-url
       :field/default-visibility    {:editor :editor.type/url
                                     :grid   :editor.type/url
                                     :filter :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/guest-sell-side
                                     :access/write :role/guest-sell-side}
       :field/translations          {:en "Statement of compliance link"}}]
     ;; IERG
     ;; IERG
     [:fund/tag-focus
      {:field/data-type             :data.type/ref-multi
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/tag-focus
       :field/default-visibility    {:editor           :editor.type/multi-select
                                     :grid             :editor.type/multi-select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Our fund focus"}}]
     [:fund/tag-valuation-guidelines-compliant
      {:field/data-type             :data.type/ref-multi
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/tag-valuation-guidelines-compliant
       :field/default-visibility    {:editor :editor.type/multi-select
                                     :grid   :editor.type/multi-select
                                     :filter :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Valuation guidelines compliant"}}]
     [:fund/tag-strategy
      {:field/data-type             :data.type/ref-multi
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/tag-strategy
       :field/default-visibility    {:editor           :editor.type/multi-select
                                     :grid             :editor.type/multi-select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Strategy"}}]
     [:fund/tag-sector
      {:field/data-type             :data.type/ref-multi
       :field/default-ord           30
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/tag-sector
       :field/default-visibility    {:editor           :editor.type/multi-select
                                     :grid             :editor.type/multi-select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Sector"}}]
     [:fund/tag-geography
      {:field/data-type             :data.type/ref-multi
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/tag-geography
       :field/default-visibility    {:editor           :editor.type/multi-select
                                     :grid             :editor.type/multi-select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Geography"}}]
     [:fund/tag-investment-roles
      {:field/data-type             :data.type/ref-multi
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/tag-investment-roles
       :field/default-visibility    {:editor :editor.type/multi-select
                                     :grid   :editor.type/multi-select
                                     :filter :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Investment roles"}}]
     [:fund/tag-investment-restrictions
      {:field/data-type             :data.type/ref-multi
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/tag-investment-restrictions
       :field/default-visibility    {:editor           :editor.type/multi-select
                                     :grid             :editor.type/multi-select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Investment restrictions"}}]
     [:fund/tag-investment-period-criteria
      {:field/data-type             :data.type/ref-multi
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/tag-investment-period-criteria
       :field/default-visibility    {:editor :editor.type/multi-select
                                     :grid   :editor.type/multi-select
                                     :filter :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Investment period criteria"}}]]
    (su/option-field :fund/type "Our fund type" {:default-field-visibility :in-use})
    [[:fund/tag-fund-type
      {:field/data-type             :data.type/ref-multi
       :value-type                  :entity
       :create-on-fly?              true
       :field/entity-types          [:entity.type/named-value]
       :named-value-attribute       :fund/tag-fund-type
       :field/default-visibility    {:editor           :editor.type/multi-select
                                     :grid             :editor.type/multi-select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read   :role/user
                                     :access/create :role/admin
                                     :access/write  :role/user}
       :field/translations          {:en "Type"}}]
     [:fund/cur-total-committed-capital
      {:field/data-type             :data.type/currency-value
       :field/secondary-attribute   :fund/cur-total-committed-capital--sym
       :field/constraints           {:constraint/number-positive        true
                                     :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility    {:editor           :editor.type/number
                                     :grid             :editor.type/number
                                     :filter           :filter.type/number
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Total committed capital"}}]
     [:fund/cur-total-committed-capital--sym
      {:field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Total committed capital (currency)"}
       :field/data-type             :data.type/currency-symbol
       :field/secondary-field?      true
       :field/not-clearable?        true
       :field/related-fields        :fund/cur-total-committed-capital
       :options                     currencies/options
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :value-type                  :keyword}]]
    (su/currency-field :fund/cur-total-called-capital
                       "Total called"
                       {:default-field-visibility :in-use})
    (su/currency-field :fund/cur-total-redrawable-capital
                       "Total redrawable"
                       {:default-field-visibility :in-use})

    [[:fund/cur-total-amounts-distributed
      {:field/data-type             :data.type/currency-value
       :field/secondary-attribute   :fund/cur-total-amounts-distributed--sym
       :field/constraints           {:constraint/number-positive        true
                                     :constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility    {:editor           :editor.type/number
                                     :grid             :editor.type/number
                                     :filter           :filter.type/number
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Total amount distributed"}}]
     [:fund/cur-total-amounts-distributed--sym
      {:field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Total amount distributed (currency)"}
       :field/data-type             :data.type/currency-symbol
       :field/secondary-field?      true
       :field/not-clearable?        true
       :field/related-fields        :fund/cur-total-amounts-distributed
       :options                     currencies/options
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :value-type                  :keyword}]
     [:fund/cur-remaining-unfunded-commitment
      {:field/data-type             :data.type/currency-value
       :field/secondary-attribute   :fund/cur-remaining-unfunded-commitment--sym
       :field/constraints           {:constraint/smaller-than-inclusive 9007199254740991}
       :field/default-visibility    {:editor           :editor.type/number
                                     :grid             :editor.type/number
                                     :filter           :filter.type/number
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Remaining unfunded commitment"}}]
     [:fund/cur-remaining-unfunded-commitment--sym
      {:field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Remaining unfunded commitment (currency)"}
       :field/data-type             :data.type/currency-symbol
       :field/secondary-field?      true
       :field/not-clearable?        true
       :field/related-fields        :fund/cur-remaining-unfunded-commitment
       :options                     currencies/options
       :field/default-visibility    {:editor           :editor.type/select
                                     :grid             :editor.type/select
                                     :filter           :filter.type/select
                                     :field-visibility :in-use}
       :value-type                  :keyword}]

     [:fund/teams
      {:field/data-type             :data.type/ref-multi
       :field/mandatory             :mandatory/always
       :value-type                  :entity
       :field/entity-types          [:entity.type/team]
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/admin}
       :field/not-importable?       true
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/none
                                     :filter           :filter.type/select
                                     :field-visibility :in-use-disabled}
       :field/translations          {:en "Authorized team(s)"}}]

     [:fund/reporting-admins                                                                        ;; rename -> :fund/reporting-admin-teams
      {:field/data-type             :data.type/ref-multi
       :value-type                  :entity
       :field/entity-types          [:entity.type/team]
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/admin}
       :field/not-importable?       true
       :field/default-visibility    {:editor           :editor.type/none
                                     :grid             :editor.type/none
                                     :filter           :filter.type/select
                                     :field-visibility :in-use-disabled}
       :field/translations          {:en "Reporting admin teams"}}]

     [:fund/description
      {:field/data-type             :data.type/text-multiline
       :field/default-visibility    {:editor           :editor.type/textarea
                                     :grid             :editor.type/textarea
                                     :filter           :filter.type/text
                                     :field-visibility :in-use}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/translations          {:en "Our fund description"}}]]
    (su/option-field :fund/external-kyc-tool
                     "External KYC"
                     {:authorization            su/access-user-user
                      :default-field-visibility :not-in-use})
    (su/keyword-multi-field :fund/pre-marketing-countries
                            "Pre-marketing permissions"
                            country/options
                            {:default-field-visibility :in-use})
    (su/keyword-multi-field :fund/marketing-countries "Marketing permissions" country/options {})
    (su/currency-field :fund/cur-NAV "NAV" {:default-field-visibility :in-use})
    (su/percentage-field :fund/net-IRR "Net IRR" {:default-field-visibility :in-use})
    (su/percentage-field :fund/gross-IRR "Gross IRR" {})
    (su/multiplier-field :fund/net-multiple "Net multiple" {:default-field-visibility :in-use})
    (su/multiplier-field :fund/gross-multiple "Gross multiple" {:default-field-visibility :in-use})
    (su/multiplier-field :fund/DPI "DPI" {:default-field-visibility :in-use})
    (su/multiplier-field :fund/gross-DPI "Gross DPI" {:default-field-visibility :not-in-use})
    (su/multiplier-field :fund/net-DPI "Net DPI" {:default-field-visibility :not-in-use})

    (su/date-field :fund/date-liquidation-date
                   "Liquidation date"
                   {:default-field-visibility :in-use})
    (su/multi-ref-field :fund/feeder-fund-to
                        "Feeder fund of"
                        [:entity.type/fund]
                        {:editor-type   :editor.type/none
                         :grid-type     :editor.type/none
                         :filter        :editor.type/select
                         :default-field-visibility :in-use
                         :authorization su/access-admin-user})
    (su/currency-field :fund/cur-management-fee
                       "Management fee"
                       {:default-field-visibility :not-in-use})
    (su/currency-field :fund/cur-distributions
                       "Distributions"
                       {:default-field-visibility :not-in-use})

    (su/calculated-field
     :fund/calc-paid-in-capital
     "Paid in capital"
     {:data-type            :data.type/currency-value
      :composite-attrs      [:holding/fund :holding/cur-paid-in-capital]
      :calculation-triggers {:entity.type/holding [[:holding/fund]]}
      :calc-fn              (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                         bigdec->float float->bigdec get-field-schema display-string]}]
                              (let [fund-holdings (reverse-lookup
                                                   {:entity                 entity-data
                                                    :attribute-entity-types [:entity.type/holding]
                                                    :attribute              :holding/fund})]
                                (->> fund-holdings
                                     (keep entity-lookup)
                                     (remove :common/disabled?)
                                     (keep :holding/cur-paid-in-capital)
                                     (map bigdec->float)
                                     (apply +)
                                     (float->bigdec))))})

    (su/calculated-field
     :fund/calc-expected-add-on
     "Expected add on"
     {:data-type            :data.type/currency-value
      :composite-attrs      [:holding/fund :holding/cur-expected-add-ons]
      :calculation-triggers {:entity.type/holding [[:holding/fund]]}
      :calc-fn              (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                         bigdec->float float->bigdec get-field-schema display-string]}]
                              (let [fund-holdings (reverse-lookup
                                                   {:entity                 entity-data
                                                    :attribute-entity-types [:entity.type/holding]
                                                    :attribute              :holding/fund})]
                                (->> fund-holdings
                                     (keep entity-lookup)
                                     (remove :common/disabled?)
                                     (keep :holding/cur-expected-add-ons)
                                     (map bigdec->float)
                                     (apply +)
                                     (float->bigdec))))})

    (su/calculated-field
     :fund/calc-expected-total-investment
     "Expected total investment"
     {:data-type            :data.type/currency-value
      :composite-attrs      [:holding/fund :holding/expected-total-investment]
      :calculation-triggers {:entity.type/holding [[:holding/fund]]}
      :calc-fn              (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                         resolve-value
                                         bigdec->float float->bigdec get-field-schema display-string]}]
                              (let [fund-holdings (reverse-lookup
                                                   {:entity                 entity-data
                                                    :attribute-entity-types [:entity.type/holding]
                                                    :attribute              :holding/fund})]
                                (->> fund-holdings
                                     (keep entity-lookup)
                                     (remove :common/disabled?)
                                     (keep (fn [holding]
                                             (resolve-value holding
                                                            :holding/expected-total-investment
                                                            entity-lookup
                                                            reverse-lookup)))
                                     (map bigdec->float)
                                     (apply +)
                                     (float->bigdec))))})

    (su/calculated-field
     :fund/calc-realized-gains
     "Realized gains"
     {:data-type            :data.type/currency-value
      :composite-attrs      [:holding/fund :holding/cur-realized-gains]
      :calculation-triggers {:entity.type/holding [[:holding/fund]]}
      :calc-fn              (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                         bigdec->float float->bigdec get-field-schema display-string]}]
                              (let [fund-holdings (reverse-lookup
                                                   {:entity                 entity-data
                                                    :attribute-entity-types [:entity.type/holding]
                                                    :attribute              :holding/fund})]
                                (->> fund-holdings
                                     (keep entity-lookup)
                                     (remove :common/disabled?)
                                     (keep :holding/cur-realized-gains)
                                     (map bigdec->float)
                                     (apply +)
                                     (float->bigdec))))})

    (su/calculated-field
     :fund/calc-book-value
     "Book value"
     {:data-type            :data.type/currency-value
      :composite-attrs      [:holding/fund :holding/cur-book-value]
      :calculation-triggers {:entity.type/holding [[:holding/fund]]}
      :calc-fn              (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                         bigdec->float float->bigdec get-field-schema display-string]}]
                              (let [fund-holdings (reverse-lookup
                                                   {:entity                 entity-data
                                                    :attribute-entity-types [:entity.type/holding]
                                                    :attribute              :holding/fund})]
                                (->> fund-holdings
                                     (keep entity-lookup)
                                     (remove :common/disabled?)
                                     (keep :holding/cur-book-value)
                                     (map bigdec->float)
                                     (apply +)
                                     (float->bigdec))))})

    (su/calculated-field
     :fund/calc-exit-value
     "Exit value"
     {:data-type            :data.type/currency-value
      :composite-attrs      [:holding/fund :holding/cur-target-exit-value]
      :calculation-triggers {:entity.type/holding [[:holding/fund]]}
      :calc-fn              (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                         bigdec->float float->bigdec get-field-schema display-string]}]
                              (let [fund-holdings (reverse-lookup
                                                   {:entity                 entity-data
                                                    :attribute-entity-types [:entity.type/holding]
                                                    :attribute              :holding/fund})]
                                (->> fund-holdings
                                     (keep entity-lookup)
                                     (remove :common/disabled?)
                                     (keep :holding/cur-target-exit-value)
                                     (map bigdec->float)
                                     (apply +)
                                     (float->bigdec))))})

    (su/calculated-field
     :fund/calc-upside
     "Upside"
     {:data-type            :data.type/currency-value
      :composite-attrs      [:holding/fund :holding/cur-upside]
      :calculation-triggers {:entity.type/holding [[:holding/fund]]}
      :calc-fn              (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                         bigdec->float float->bigdec get-field-schema display-string]}]
                              (let [fund-holdings (reverse-lookup
                                                   {:entity                 entity-data
                                                    :attribute-entity-types [:entity.type/holding]
                                                    :attribute              :holding/fund})]
                                (->> fund-holdings
                                     (keep entity-lookup)
                                     (remove :common/disabled?)
                                     (keep :holding/cur-upside)
                                     (map bigdec->float)
                                     (apply +)
                                     (float->bigdec))))})

    (su/calculated-field
     :fund/calc-expected-multiple
     "Expected multiple"
     {:data-type            :data.type/multiplier
      :editor-type          :editor.type/multiplier
      :composite-attrs      [:holding/fund :holding/expected-multiple]
      :calculation-triggers {:entity.type/holding [[:holding/fund]]}
      :calc-fn              (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                         resolve-value
                                         bigdec->float float->bigdec get-field-schema display-string]}]
                              (let [fund-holdings (->> (reverse-lookup {:entity                 entity-data
                                                                        :attribute-entity-types [:entity.type/holding]
                                                                        :attribute              :holding/fund})
                                                       (keep entity-lookup)
                                                       (remove :common/disabled?))
                                    dividend (->> fund-holdings
                                                  (keep (fn [holding]
                                                          (resolve-value holding
                                                                         :holding/cur-target-exit-value
                                                                         entity-lookup
                                                                         reverse-lookup)))
                                                  (map bigdec->float)
                                                  (apply +))
                                    expected-add-ons (->> fund-holdings
                                                          (keep (fn [holding]
                                                                  (resolve-value holding
                                                                                 :holding/cur-expected-add-ons
                                                                                 entity-lookup
                                                                                 reverse-lookup)))
                                                          (map bigdec->float)
                                                          (apply +))
                                    paid-in-capital (->> fund-holdings
                                                         (keep (fn [holding]
                                                                 (resolve-value holding
                                                                                :holding/cur-paid-in-capital
                                                                                entity-lookup
                                                                                reverse-lookup)))
                                                         (map bigdec->float)
                                                         (apply +))
                                    divider (+ expected-add-ons paid-in-capital)]
                                ;; A number, as the data type says. A divider of zero gives no multiple.
                                (when-not (zero? divider)
                                  (/ dividend divider))))})

    (su/text-edn-field :fund/transaction-process-config
                       "Transaction process configuration"
                       {:authorization       su/access-admin-user
                        :hidden-from-config? true})

    (su/boolean-field :fund/lux-fund?
                      "Lux fund"
                      {:authorization            su/access-admin-user
                       :default-field-visibility :not-in-use})
    ;; Set only by the discontinue LP reporting endpoint. The decision is permanent.
    (su/boolean-field :fund/reporting-discontinued?
                      "Reporting discontinued"
                      {:authorization            su/access-system-user
                       :system-semantics         su/system-controlled-not-clearable-field-semantics
                       :editor                   :editor.type/none
                       :default-field-visibility :not-in-use
                       :not-importable?          true})

    ; Todo add default IC list somehow. Maybe through spv
    )))
